/**
 *  Date    : 2020/03/09
 *  Author  : lbb1811
 *  Declare : 页面跳转路径
 */

const PAGE = {

  HOME: '/rayh5/home', // 首页
  BOOK_SEARCH: '/rayh5/home/search', // 书籍搜索
  RESOURCE_SQUARE: '/rayh5/home/resource', // 资源广场
  HOT_COURSE: '/rayh5/home/course', // 热门课程
  HOT_BOOK_LIST: '/rayh5/home/booklist', // 热门书单
  PRINTER_PAGE: '/rayh5/home/printer', // 资料打印
  BOOK_LIST_DETIAL: '/rayh5/book/booklistdetail', // 书单详情
  RAY_INTRODUCE: '/rayh5/introduce',  //小睿介绍页
  FEED_BACK_TYPE: '/rayh5/feedback',        //小睿反馈
  FEED_BACK_CONTENT: '/rayh5/feedback/content',        //小睿反馈

  OLD_BOOK: '/rayh5/book/old', // 未配置的书 进入旧版
  BOOK: '/rayh5/book', // 本书服务
  BOOK_SHELF: '/rayh5/mine/bookshelf', // 我的书架
  BOOK_GUIDE: '/rayh5/book/guide', // 书籍引导

  MINE_NEWS: '/rayh5/mine/news', // 资讯

  MINE: '/rayh5/mine', // 个人中心
  MINE_PERSONAL: '/rayh5/mine/personal', // 个人设置
  MINE_PERSONAL_NAME: '/rayh5/mine/setname', // 个人设置 名称,

  LOGIN_HOME: '/rayh5/login', //登录首页
  SELECT_AREA_CODE: '/rayh5/login/selectareacode', //选择区号
  APPLET: '/rayh5/applet', //小程序入口

  MEMBER: '/rayh5/member', // 会员红包
  MYMEMBER: '/rayh5/member/mymember', // 我的会员
  ALLMEMBER: '/rayh5/member/allmember', // 全部会员活动
  MEMBER_DETAIL: '/rayh5/member/detail', // 会员详情
  MEMBER_SPECIAL: '/rayh5/member/special', // 会员专区
  MEMBER_PAY: '/rayh5/member/pay', // 购买会员
  MEMBER_GUIDE: '/rayh5/member/guide', // 活动指引
  DOU_LUO: '/rayh5/douluo/info', //斗罗大陆

  // 多元测试
  MULTIVARIATE: '/rayh5/multivariate',
  MULTIVARIATE_DETAILS: '/rayh5/multivariate/details',
  MULTIVARIATE_QUESTION: '/rayh5/multivariate/question',
  MULTIVARIATE_REPORT_RESULT: '/rayh5/multivariate/report/result',
  MULTIVARIATE_REPORT_SEARCH: '/rayh5/multivariate/report/search',

  // 学科学习力测评
  LEARNING: '/rayh5/learning',
  LEARNING_QUESTION: '/rayh5/learning/question',
  LEARNING_REPORT: '/rayh5/learning/report',

  // 儿童情商测评
  EVALUATION_EMOTIONAL: '/rayh5/evaluation/emotional',
  EVALUATION_EMOTIONAL_QUESTION: '/rayh5/evaluation/emotional/question',
  EVALUATION_EMOTIONAL_REPORT: '/rayh5/evaluation/emotional/report',

  // 专注力测评
  EVALUATION_CONCENTRATION: '/rayh5/evaluation/concentration',
  EVALUATION_CONCENTRATION_QUESTION: '/rayh5/evaluation/concentration/question',
  EVALUATION_CONCENTRATION_REPORT: '/rayh5/evaluation/concentration/report',
  // 书法习惯测评
  EVALUATION_CALLIGRAPHY: '/rayh5/evaluation/calligraphy',
  EVALUATION_CALLIGRAPHY_QUESTION: '/rayh5/evaluation/calligraphy/question',
  EVALUATION_CALLIGRAPHY_REPORT: '/rayh5/evaluation/calligraphy/report'
};

export default PAGE;
